export enum BdcPhotoQuality {
  LOW = 'low',
  HIGH = 'high',
}

export interface BdcPhotoInRoomGallery {
  url?: string
  room_id: number
}

export interface BdcPhotoInPropertyGallery {
  url?: string
  property_id: number
}

export type BdcPhotoMetadata = {
  tag_ids: number[]
  url?: string
  name: string
  /**
   * Specifies the preferred resolution if the uploaded photo is of low quality.
   * */
  message: string
  in_room_galleries: BdcPhotoInRoomGallery[]
  photo_id: string
  in_property_gallery: BdcPhotoInPropertyGallery
  width: number
  height: number
  quality: BdcPhotoQuality
  sample: string
}

export interface BdcGetPhotosMetadataResponseData {
  photos: BdcPhotoMetadata[]
}

export enum BdcPendingPhotoStatus {
  NEW = 'new',
  OK = 'ok',
  ENQUEUED = 'enqueued',
  BAD_URL = 'bad_url',
  DUPLICATE = 'duplicate',
  ERROR = 'error',
  ERROR_DECODE = 'error_decode',
}

export interface BdcPendingPhotoStatusData {
  url: string
  request_timestamp: string
  photo_pending_id: string
  photo_id: string
  status_message: string
  status: BdcPendingPhotoStatus
}

export enum BdcListingPhotoStatus {
  LOCAL = 'local',
  ENQUEUED = 'enqueued',
  REJECTED = 'rejected',
  LIVE = 'live',
  OK = 'ok',
}

export interface BdcListingPhoto {
  status: BdcListingPhotoStatus
  url: string
  tokeetPhotoId?: string
  processingMessage?: string
  lowQualityResolutionMessage?: string
  bdcPhotoId?: string
  quality?: BdcPhotoQuality
}

export interface BdcPhotoTag {
  id: number
  tag: string
}

/* {
  "status_message": "The photo has been enqueued for processing.",
  "status": "enqueued",
  "request_timestamp": "2025-04-24 10:37:39",
  "url": "https://res.cloudinary.com/tokeet/image/upload/v1745483857/stage/abvzmoganx4j2fj1nmsi.png",
  "photo_pending_id": "WEh1MZuknmg"
}*/

export interface BdcPendingPhoto {
  status_message: string
  status: BdcListingPhotoStatus
  request_timestamp: string
  url: string
  photo_pending_id: string
}

export interface BdcGetPageParams {
  limit?: number
  cursor?: string
}

export interface BdcPhotoToUpload {
  url: string
  tag_ids?: number[]
}

export interface BdcPhotoUploadPayload {
  photos: BdcPhotoToUpload[]
}

export interface BdcPhotoUploadResponseData {
  photo_batch_id: string
}

export interface BdcUpdatePhotoTagsPayload {
  tag_ids: number[]
}

export interface BdcUpdatePhotoGalleryPayload {
  // Contains the photo ids that you want to move to the property-level photo gallery.
  insert_photos?: string[]
  // Contains the photo ID that you want to remove from the property-level photo gallery.
  remove_photos?: string[]
  // Contains the photo ids in the order that you want them to be in.
  order?: string[]
}

export interface BdcUpdatePropertyPhotoGalleryPayload extends BdcUpdatePhotoGalleryPayload {
  // Contains the photo ID that you want to set as the main photo.
  main_photo?: string
  // Indicates whether the photos in the property's photo gallery are ordered using Booking.com's machine learning algorithm.
  smart_ordering?: 0 | 1
}

export type BdcUpdateRoomPhotoGalleryPayload = BdcUpdatePhotoGalleryPayload

export type BdcPhotoGalleryPhotoItem = {
  url: string
  name: string
  photo_id: string
}

export interface BdcPhotoGalleryData {
  order: BdcPhotoGalleryPhotoItem[]
}

export interface BdcPropertyPhotoGalleryData extends BdcPhotoGalleryData {
  main_photo?: BdcPhotoGalleryPhotoItem
  smart_ordering?: 0 | 1
}

export type BdcRoomPhotoGalleryData = BdcPhotoGalleryData
